'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DESplash = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _glamorous2.default.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
});

var Logo = _glamorous2.default.img({
  maxHeight: 150,
  maxWidth: '100%'
});

var Title = _glamorous2.default.h1({
  color: _.Colors.GREY1,
  fontSize: _.FontSizes.SIZE1,
  fontWeight: 'normal'
});

var DESplash = exports.DESplash = function DESplash(_ref) {
  var title = _ref.title,
      logo = _ref.logo;
  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement(Logo, { src: logo, alt: 'logo' }),
    _react2.default.createElement(
      Title,
      null,
      title
    )
  );
};

DESplash.propTypes = {
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
  logo: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-splash/index.js
// module id = 2027
// module chunks = 0